import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IIncidentType } from '@/api/routes/incident-types/types';

import { fetchIncidentTypes } from './actionCreators';

interface InitialState {
  incidentTypes: IIncidentType [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  incidentTypes: [],
  isLoading: false,
  error: '',
};

export const incidentTypesSlice = createSlice({
  name: 'incidentTypes',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchIncidentTypes.fulfilled.type]: (state, action: PayloadAction<IIncidentType []>) => {
      state.isLoading = false;
      state.error = '';
      state.incidentTypes = action.payload;
    },
    [fetchIncidentTypes.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchIncidentTypes.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default incidentTypesSlice.reducer;
